import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import SolutionVideo from "./Passwordless.mp4";
import RiskGraphic from "./RiskFree.png";
import HelpGraphic from "./HowWeHelp.png";
import { OutboundLink } from '@assertiv/assertiv-gatsby-plugin-google-gtag'


export default class SectionOne extends React.Component {

    render() {

        var featureName = "Passwordless Login";


        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How can we help?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <img alt={"EngineID " + featureName } className={styles.tabletRightImage} src={HelpGraphic} />
                                    <p>
                                        EngineID is a cloud-based Identity and Access Management system. One of the key features of this is our {featureName} capability. Your 
                                        staff get a push notification directly to their mobile device which logs users in by only having to supply a username. That’s it!
                                    </p>
                                    <p>
                                        {featureName} is coupled perfectly with EngineID’s App Launch Dashboard and Single Sign-On capability, these features are included in all 
                                        EngineID plans (even the free one). Your staff can login securely without a password and load corporate applications at the click (or tap) of a button.
                                    </p>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="How it works?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            Passwordless Login is easily accessible from the Login screen on EngineID. Your staff are sent a notification directly to their 
                                            mobile device. All they need to do is match the number on screen with the number on their mobile device and EngineID takes care of the rest.
                                        </p>
                                    </div>
                                    <div className={ "w-100" }>
                                        <video controls className={ "w-100" }>
                                            <source src={SolutionVideo} type="video/mp4" />
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-10">
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Why use EngineID?" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            EngineID has been specializing in Identity and Authentication solutions since 2016. Our feature rich platform solves a wide range of complex challenges, with {featureName} a core component of what we do.
                                        </p>
                                        <p>
                                            When you use EngineID, you receive many benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>An expert team of Identity and Authentication specialists and developers. Our focus is on solving complex challenges such as consolidation of diverse application landscapes.</li>
                                                <li>No additional servers required. Connect to our cloud hosted solution to use EngineID immediately.</li>
                                                <li>Ongoing support and enhancements of our solution. As a cloud product, we handle all patching and upgrades.</li>
                                                <li>Ongoing testing of our solution improves confidence of a secure solution.</li>
                                                <li>Highly scalable solution to cater for any number of users.</li>
                                                <li>EngineID is not limited to {featureName}. There is a <OutboundLink href="../features">long list</OutboundLink> of included features you get at no additional cost.</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Access Management is important to get right. Let EngineID up-lift your access strategy with confidence. In fact, we’re so confident in the EngineID product that we offer
                                            a <OutboundLink href="https://app.engineid.com/register">free plan</OutboundLink> that you can use right away.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID OpenID Connect" className={styles.tabletImage} src={RiskGraphic} />
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}